import React from 'react';
import Tooltip from '@homeaway/react-tooltip';
import {IS_BROWSER} from '../../../../utils/dynamic-rendering';

const FreeCancellationMsg = ({badgeText}) => (
    <strong className="label label-default">{badgeText}</strong>
);

const Wrapper = ({children}) => (
    <span className="FreeCancellation">{children}</span>
);

const FreeCancellation = ({isDesktop, badgeText, tooltipText}) => {
    if (isDesktop && tooltipText) {
        const props = {
            tooltipType: 'popover',
            placement: 'top',
            centered: true,
            content: tooltipText,
            ...(IS_BROWSER && {
                parentNode: window.document.body,
            }),
        };
        return (
            <Wrapper>
                <Tooltip {...props}>
                    <FreeCancellationMsg badgeText={badgeText} />
                </Tooltip>
            </Wrapper>
        );
    }
    return (
        <Wrapper>
            <FreeCancellationMsg badgeText={badgeText} />
        </Wrapper>
    );
};

export default FreeCancellation;
